import React from 'react';
import { InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { listSearchIconSx } from '../../Map/components/UserLotListsPanel/UserLotListsPanel.styles';

/** Ancho del ícono de búsqueda (20 px) + su margen: el texto del input arranca en 14 + 20 + 8 px. */
export const LEAD_SEARCH_ICON_SLOT = 20;

/**
 * Lupa al inicio de los buscadores de los diálogos de Leads (lead, registros),
 * con el mismo ícono / tamaño / color que el buscador del panel de Leads y Mis listas.
 */
export default function LeadSearchAdornment() {
  return (
    <InputAdornment position="start">
      <SearchIcon sx={listSearchIconSx} aria-hidden />
    </InputAdornment>
  );
}
